import { render, staticRenderFns } from "./takeaway_export.vue?vue&type=template&id=b1673bb4&scoped=true&"
import script from "./takeaway_export.vue?vue&type=script&lang=js&"
export * from "./takeaway_export.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1673bb4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b1673bb4')) {
      api.createRecord('b1673bb4', component.options)
    } else {
      api.reload('b1673bb4', component.options)
    }
    module.hot.accept("./takeaway_export.vue?vue&type=template&id=b1673bb4&scoped=true&", function () {
      api.rerender('b1673bb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/takeaway/takeaway_export.vue"
export default component.exports